import { useEffect, useRef } from "react";
import type { Awareness } from "y-protocols/awareness";
import { bindPresenceToAwareness } from "../../stores/presence";

interface PresenceProviderProps {
  awareness: Awareness | null;
  userName: string;
  userColor: string;
  children: React.ReactNode;
}

function PresenceProvider({
  awareness,
  userName,
  userColor,
  children,
}: PresenceProviderProps) {
  const cleanupRef = useRef<(() => void) | null>(null);

  useEffect(() => {
    if (!awareness) return;

    cleanupRef.current = bindPresenceToAwareness(awareness, userName, userColor);

    return () => {
      cleanupRef.current?.();
      cleanupRef.current = null;
    };
  }, [awareness, userName, userColor]);

  return <>{children}</>;
}

PresenceProvider.displayName = "PresenceProvider";

export { PresenceProvider };
export type { PresenceProviderProps };
